import axios from "axios";
import { store } from "../store";
import { openAuthDialog } from "../slices/authDialog";

const baseURL = process.env.REACT_APP_BASE_URL;

const axiosInstance = axios.create({
  baseURL: baseURL,
  headers: {
    "x-vccrm-csrf-protection": "x-vccrm-csrf-protection",
    "Cache-Control": "no-store",
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

// Add a response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    // If the response is successful (status code in the range of 2xx), just return the response
    return response;
  },
  async (error) => {
    // Check if the error response is a 401 Unauthorized
    if (error.response && error.response.status === 401) {
      // Dispatch action to open the auth dialog
      store.dispatch(
        openAuthDialog({
          message: "You are about to be signed out...",
        })
      );
    }

    // For all other errors, reject the promise so it can be handled elsewhere
    return Promise.reject(error);
  }
);

export default axiosInstance;
